<template>
	<div class="phone-channel-cls">
		<section class="left-cls" :class="{'show': isSwitch}">
			<div @click.stop="isSwitch = !isSwitch" class="on-switch" :class="isSwitch ? 'el-icon-d-arrow-left' : 'el-icon-d-arrow-right'"></div>
			<LeftItem @handleActiveNameLeft="handleActiveNameLeft" :activeName="activeName" />
		</section>
		<section id="rightContainer" class="right-cls" :class="{'width': !isSwitch}">
			<RightItem @handleActiveNameRight="handleActiveNameRight" :row="row" :activeName="activeName" />
		</section>
	</div>
</template>

<script>
import LeftItem from "./LeftItem";
import RightItem from "./RightItem";
export default {
	name: "TelChannelPageIndex",
	components: {LeftItem, RightItem},
	data() {
		return {
			isSwitch: true,
			row: null,
			activeName: ''
		}
	},
	methods: {
		handleActiveNameLeft(row, activeName) {
			this.row = {
				phoneNumber: row.phoneNumber,
				histId: row.histId,
				custId: row.custId,
				iaId: row.iaId
			};
			this.activeName = activeName;
		},
		handleActiveNameRight(activeName, length) {
			if(length === 0) {
				this.row = null;
				this.activeName = '';
				return;
			}
			this.activeName = activeName;
		}
	}
}
</script>

<style lang="scss" scoped>
.phone-channel-cls {
	width: 100%;
	height: calc(100vh - 94px);
	overflow: hidden;

	& > .left-cls {
		display: inline-block;
		vertical-align: top;
		width: 15px;
		height: 100%;
		border-right: 1px solid #D8D8D8;
		box-sizing: border-box;
		position: relative;
		overflow: hidden;
		transition: width .2s;
		padding-top: 16px;
		box-sizing: border-box;

		&.show {
			width: 320px;
		}

		& > .on-switch {
			width: 12px;
			height: 230px;
			position: absolute;
			top: calc((100% - 230px) / 2);
			right: 0;
			border-top-left-radius: 12px;
			border-bottom-left-radius: 12px;
			border: 1px solid #C3C9D0;
			border-right: none;
			cursor: pointer;
			background: #fff;
			z-index: 2;
			line-height: 230px;
			text-align: left;
			color: #337EFF;
			font-weight: 900;
			font-size: 12px;
		}
	}

	& > .right-cls {
		display: inline-block;
		vertical-align: top;
		width: calc(100% - 320px);
		height: calc(100vh - 100px);
		position: relative;
		left: -1px;
		overflow-x: hidden;
		overflow-y: auto;
		padding-top: 16px;
		box-sizing: border-box;
		transition: width .2s;
		&::-webkit-scrollbar {
			width: 0;
		}

		&.width {
			width: calc(100% - 15px);
		}
	}
}
</style>

